import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageAdsAirDuct.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
import axios from 'axios';

// images
import AreaData from '../ServicesPage/AreaData'
import LocationReviewsData from './LocationReviewsData';
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageAdsAirDuct({ locationsMainAirDuct, CitiePhone, CitiesData }) {
    const [input, setInput] = useState('how to fix garage door');
    const [response, setResponse] = useState({});
    const location = useLocation()
    const navigate = useNavigate()
    const [CustInfoUpdate, setCustInfoUpdate] = useState(false);

    const [FormSubmiting, setFormSubmiting] = useState(false);
    const url = new URL(window.location.href);

    const fireBhoCall = () => {
        if (typeof window === "undefined") return;
        if (url.searchParams.get("spg") !== "o") return;
        if (typeof window.oaiq !== "function") return;
        const eventName = "bho_air_duct_phone_call";
        try {
            window.oaiq("measure", "custom", { type: "custom" }, {
                custom_event_name: eventName,
                event_id: `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
            });
        } catch (e) { }
    };

    const [CustInfo, setCustInfo] = useState({
        FirstName: '',
        Email: '',
        Phone: '',
        Address: '',
        Message: ''
    });
    const FinalMessage = `
*New Contact Form Submission*

SPG: ${url.searchParams.get('spg') == "g" ? "Google" : url.searchParams.get('spg') == "m" ? "Microsoft" : url.searchParams.get('spg') == "o" ? "🤖 OpenAI" : "Null"} | ${url.searchParams.get('ct') == "pmax" ? "pMax" : "Search"} || ${url.searchParams.get('handyby') == "yes" ? "HandyBy: *🟦 Yes*" : "H: *No*"}
Company name: BHO Chimney Sweep | Air Duct
Lead source: Online Booking
Name: ${CustInfo.FirstName}
Phone: ${CustInfo.Phone}
Address: ${CustInfo.Address}
Message: ${CustInfo.Message}

> Please contact the customer as soon as possible to discuss their needs and schedule an appointment. Thank you!    
`


    const sentJobToWhatsapp = async () => {
        await fetch("https://api.ultramsg.com/instance120323/messages/chat", {
            method: "POST",
            body: new URLSearchParams({
                token: "ijne8s82zyrs5n7t",
                to: "120363419437168717@g.us",
                body: FinalMessage,
            }),
        }
        );
    }
    function sendEmail(e) {

        console.log(FinalMessage);

        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it
        if (e.target.Message) e.target.Message.value = e.target.Message.value + "\nLead source: Online Booking";
        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                sentJobToWhatsapp()
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    const data = {
        title: "",
        rows: [
            {
                title: "Why choose BHO Chimney Sweep?",
                content: "With 50 years of expertise, BHO Chimney Sweep provides professional, reliable air duct services, ensuring cleaner indoor air and efficient HVAC performance in every home."
            },
            {
                title: "What does BHO stand for?",
                content: "BHO stands for Bob and Henry Oliver, the founders who built the company with a focus on quality service, reflecting decades of trusted care for your home's air systems."
            },
            {
                title: "What services do you offer?",
                content: "We offer air duct cleaning, duct inspection, HVAC vent repair, dryer vent cleaning, duct sanitizing, and full system maintenance to improve air quality and airflow."
            },
            {
                title: "How much is an air duct inspection?",
                content: "We offer a free air duct inspection! Our technician will evaluate your ductwork for buildup, blockages, and signs of damage during the visit."
            },
            {
                title: "Can you clean and repair during the same visit?",
                content: "Yes, we offer same-day cleaning and repair services during your appointment whenever possible."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                title: "How do I book an appointment?",
                content: `Call us <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search}&service=airduct'}>online form</a> to schedule your visit.`
            }
        ]
    };

    const styles = {
        bgColor: '#eceef6',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#2a1768',
        rowTitleTextSize: '21px',
        rowContentColor: '#242424',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#2a1768",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "bho chimney sweep" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and bho chimmney sweep from title)(if no keywords just do for air duct and dryer vent) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);


    return (
        <div className="HomePageAdsAirDuct" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>BHO Chimney Sweep | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Chimney Sweep | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Chimney Sweep | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.bhochimneysweep.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Chimney Sweep provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Chimney Sweep provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Chimney Sweep" data-react-helmet="true" />
                <meta name="keywords" content="chimney sweep, chimney Inspection, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, chimney services, chimney service, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Insulation, Chimney Installation, Chimney Liner Repair, Chimney Pointing, Chimney Rainp Installation, Chimney Repair, Chimney Crown Repair, Chimney Restoration, Chimney Flue Installation, Chimney Flue Repair, ​Chimney Construction, Chimney Vent Installation, Chimney Flashing, Flexible Chimney Liner Installation, Chimney Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>

            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>The Air Ducts Experts You've Trusted for Over 50 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct & Dryer Vent Cleaning, Repair, Maintenance Near You</h2>
                    {/* <h2>Servicing <b>{CitiesData && CitiesData.City? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas - Chimney Inspections, Repairs And Cleaning Near Me</h2> */}
                    {/* <h2>Chimney Services, Repairs And Cleaning Near Me</h2> */}
                    {/* <h2>Chimney Cleaning Near Me</h2> */}
                    <h3><img src={require(`../../Images/checklist.png`)} alt="Locally Owned & Operated BHO Chimney Sweep Repair" />Locally Owned & Operated</h3>
                    <h3><img src={require(`../../Images/checklist.png`)} alt="Licensed | Bonded | Insured BHO Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                    <h3><img src={require(`../../Images/checklist.png`)} alt="Satisfaction Guaranteed BHO Chimney Sweep Repair" />Satisfaction Guaranteed</h3>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>{CitiePhone}</a>
                        <a onClick={() => navigate(`/book${location.search}&service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me BHO" /></a>
                    </div>
                </div>
                <div className="MainBannerRight">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Banner1LogoAirDuct.png`)} alt="Chimney Sweep BHO | Chimney Repair BHO | Chimney Services BHO | Chimney Inspection BHO" />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
            {/* BookAnAppointmentMainComponentEmergery */}
            <div className="BookAnAppointmentMainComponentEmergery">
                <div className="BookAnAppointmentMainComponentRates">
                    <span className="GoogleButt">
                        <h6>5 STAR - Based On 1,836 Reviews</h6>
                    </span>
                    <div className="BookAnAppointmentMainComponentRatesImages">
                        <img src={require(`../../Images/YELP.png`)} alt="BHO Chimney Sweep Cleaning Yelp Review" />
                        <img src={require(`../../Images/Angie.png`)} alt="BHO Chimney Sweep Cleaning Angie Review" />
                        <img src={require(`../../Images/HomeAdvisor.png`)} alt="BHO Chimney Sweep Cleaning HomeAdvisor Review" />
                        <img src={require(`../../Images/BBB.png`)} alt="BHO Chimney Sweep Cleaning BBB Review" />
                        <img src={require(`../../Images/Google.png`)} alt="BHO Chimney Sweep Cleaning Google Review" />
                        <img src={require(`../../Images/Porch.png`)} alt="BHO Chimney Sweep Cleaning Porch Review" />
                        <img src={require(`../../Images/check.jpg`)} alt="BHO Chimney Sweep Cleaning Trust Review" />
                    </div>
                    <h1>Customer Testimonials</h1>
                    <h2>⭐⭐⭐⭐⭐</h2>
                    <h3>
                        I’ve used BHO Air Duct Cleaning for <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', ',') : url.searchParams.get('kd') + "," : "Maintenance"}</span> and other air duct cleaning & repairs, and I’m always impressed with their level of service. They use top-quality equipment and are very detail-oriented. My indoor air has never felt cleaner, and I appreciate their commitment to safety and customer satisfaction.
                        <br />
                        <br />
                        <a onClick={() => window.location.hash = 'reviews'}>MORE FROM OUR CUSTOMERS &gt;</a>
                    </h3>

                </div>
                <div className="BookAnAppointmentMainComponentEmergeryBox">
                    <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>For emergency service Call: {CitiePhone}</a>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2" id="ourservices">
                <div className="MainBanner2TopBox">
                    <div className="MainBanner2TopBoxBack">
                        {/*  */}
                    </div>
                    <div className="MainBanner2TopBoxMain">
                        <h2>OUR AIR DUCTS SERVICES</h2>
                        <div className="MainBanner2TopBoxMenu">
                            <a className="MainBanner2TopBoxBox">
                                <img src={require(`../../Images/chimneycleaning.png`)} alt="Air Duct & Dryer Vent Cleaning" />
                                <h3>Air Duct & Dryer Vent Cleaning</h3>
                                <h4>Clean, Clear & Safe</h4>
                                <h2>Thorough removal of dust, lint, and debris to improve airflow, air quality, and reduce fire hazards.</h2>
                            </a>

                            <a className="MainBanner2TopBoxBox">
                                <img src={require(`../../Images/chimneyinspection.png`)} alt="Air Duct & Dryer Vent Repair" />
                                <h3>Air Duct & Dryer Vent Repair</h3>
                                <h4>Seal, Fix & Restore</h4>
                                <h2>We repair damaged ducts and vents to restore safety, boost system efficiency, and lower energy costs.</h2>
                            </a>

                            <a className="MainBanner2TopBoxBox">
                                <img src={require(`../../Images/chimneymaintenance.png`)} alt="Duct Services" />
                                <h3>Ducts Services</h3>
                                <h4>Full-System Solutions</h4>
                                <h2>From inspections to replacements, we provide complete ductwork services tailored to your property’s needs.</h2>
                            </a>

                            <a className="MainBanner2TopBoxBox">
                                <img src={require(`../../Images/chimneyrepair.png`)} alt="Duct Maintenance" />
                                <h3>Ducts Maintenance</h3>
                                <h4>Preventative Care</h4>
                                <h2>Keep your HVAC system running smoothly with routine duct maintenance that prevents costly repairs.</h2>
                            </a>

                        </div>
                        <div className="MainBanner2TopBoxMainChat">
                            <img src={require(`../../ImagesLogos/Image1LogoAirDuct.png`)} />
                            <div className="MainBanner2TopBoxMainChatText">
                                <h4>{response.title}</h4>
                                <h3>{response.body}</h3>
                                <h5>Call us at <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}&service=airduct`}>online form</a> to schedule your visit.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* MainBanner2 */}
            <div className="MainBanner2" id="about">
                <div className="MainBanner2TopTop">
                    <div className="MainBanner2TopTopLeft">
                        <img src={require(`../../Images/Chimney3.jpeg`)} alt="Chimney Sweep BHO | Chimney Repair BHO | Chimney Services BHO | Chimney Inspection BHO" />
                    </div>
                    <div className="MainBanner2TopTopRight">
                        <h4>LEAVE DUCTS TO THE PROS</h4>
                        <h5>BECAUSE WITH BHO CHIMNEY SWEEP, YOU GET MORE THAN JUST A SERVICE—YOU GET PEACE OF MIND.</h5>
                        <div className="MainBanner2TopBox">
                            <h2>REPUTATION</h2>
                            <h3>Trusted air ducts experts since 1975 in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Delivering exceptional service and craftsmanship with decades of proven expertise.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>TRANSPARENCY</h2>
                            <h3>No hidden fees—our honest pricing covers air ducts & dryer vents services any time, including holidays.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>EFFICIENCY</h2>
                            <h3>Prompt same-day and emergency air ducts & dryer vents services, available 365 days a year to meet your needs.</h3>
                        </div>
                        <div className="MainBanner2TopBox">
                            <h2>QUALITY</h2>
                            <h3>Comprehensive air ducts & dryer vents, from cleaning to repair, using advanced techniques and the latest equipment.</h3>
                        </div>
                    </div>
                </div>
                {/* Title */}
                <div className="MainBanner2TopTopBtn">
                    <div className="MainBanner2TopTopBtnLeft">
                        <img src={require(`../../Images/tag.png`)} alt="" />
                        <span>
                            <h1>$69 Chimney Inspection Service</h1>
                            <h2>Chimney cleaning in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> is not merely about appearances; it's a crucial step in safeguarding your home's air quality and overall safety. Regular cleaning reduces the buildup of harmful contaminants and ensures that your chimney operates efficiently, minimizing potential fire hazards.</h2>
                        </span>
                    </div>
                    <div className="MainBanner2TopTopBtnRight">
                        <a onClick={() => navigate(`/book${location.search}&service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep BHO | Chimney Repair BHO | Chimney Services BHO | Chimney Inspection BHO" /></a>
                        <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>CALL NOW {CitiePhone}</a>
                    </div>
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment response={response} CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* MainBanner3 */}
            <div className="MainBanner3">
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Air Duct Cleaning</h2>
                            <h3>
                                Professional Air Duct Cleaning Services in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}
                                <br />
                                <br />
                                Air duct cleaning is essential for maintaining healthy indoor air quality and ensuring your HVAC system runs efficiently. Over time, dust, allergens, and debris build up in your ductwork, circulating throughout your home and impacting your health. Our skilled technicians use advanced equipment to thoroughly clean your air ducts, helping you breathe easier and live healthier.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airduuctcleaning.webp`)} alt="Air Duct Cleaning BHO" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Dryer Vent Cleaning</h2>
                            <h3>
                                Expert Dryer Vent Cleaning Services
                                <br />
                                <br />
                                Regular dryer vent cleaning is essential for fire prevention and optimal dryer performance. Over time, lint and debris can clog your dryer vent, creating serious fire hazards and increasing drying time. Our experienced technicians provide thorough vent cleaning to ensure proper airflow, improve energy efficiency, and keep your home safe.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryerventcleaning.jpg`)} alt="Dryer Vent Cleaning BHO" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Air Duct Repair</h2>
                            <h3>
                                Professional Air Duct Repair Services
                                <br />
                                <br />
                                At BHO Chimney Sweep, we provide expert air duct repair services to restore the performance of your HVAC system. Over time, air ducts can develop leaks, disconnections, or damage that reduce efficiency and compromise air quality. Our skilled technicians specialize in sealing leaks, repairing damaged sections, and restoring proper airflow—ensuring your system runs smoothly and your indoor environment stays clean and comfortable.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airdductrepair.webp`)} alt="Air Duct Repair BHO" />
                        </div>
                    </div>

                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Dryer Vent Repair</h2>
                            <h3>
                                Reliable Dryer Vent Repair Services
                                <br />
                                <br />
                                At BHO Chimney Sweep, we specialize in professional dryer vent repairs to ensure safe and efficient dryer operation. Blocked, damaged, or disconnected vents can cause overheating, fire hazards, and longer drying times. Our experienced technicians diagnose and fix dryer vent issues, restoring proper airflow and improving your system’s performance and safety.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/dryerrepair.jpg`)} alt="Dryer Vent Repair BHO" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Ducts Service & Maintenance</h2>
                            <h3>
                                Complete Air Duct Care for Your Home or Business
                                <br />
                                <br />
                                Air ducts require regular service and maintenance to operate efficiently and keep your indoor air clean. BHO Chimney Sweep provides thorough duct system evaluations, cleaning, sealing, and routine maintenance to prevent air leaks, buildup, and energy loss. Count on us to maintain the health and performance of your HVAC system with reliable, long-lasting solutions.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airductservice.webp`)} alt="Ducts Service and Maintenance BHO" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Air Duct & Dryer Vent Inspection</h2>
                            <h3>
                                Thorough Inspection for Safe and Efficient Ventilation
                                <br />
                                <br />
                                Regular inspections of your air ducts and dryer vents are crucial for identifying blockages, leaks, or damage that can reduce air quality and pose fire risks. BHO Chimney Sweep provides expert inspection services to ensure your ductwork and vents are functioning properly, safely, and efficiently. We help detect issues early—saving you money and improving indoor air health.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airdutcinspection.avif`)} alt="Air Duct and Dryer Vent Inspection BHO" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Air Duct Sanitation & UV Light</h2>
                            <h3>
                                Advanced Duct Disinfection & UV Light Installation
                                <br />
                                <br />
                                BHO Chimney Sweep offers professional air duct sanitation combined with UV light solutions to eliminate mold, bacteria, and allergens from your HVAC system. Our sanitation services deeply disinfect your ducts, while UV light technology continuously neutralizes airborne contaminants—helping improve air quality, reduce odors, and create a safer, healthier home environment.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/airductuv.jpg`)} alt="Air Duct Sanitation and UV Light BHO" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>Ducts Replacement</h2>
                            <h3>
                                Professional Air Duct Replacement Services
                                <br />
                                <br />
                                BHO Chimney Sweep provides expert duct replacement services to improve HVAC efficiency, air quality, and energy performance. Whether your ducts are old, damaged, leaking, or poorly designed, replacing them ensures safe, consistent airflow and reduces heating and cooling costs. Our technicians deliver reliable, high-quality ductwork replacement tailored to your home or business needs.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ducts.jpg`)} alt="Duct Replacement BHO" />
                        </div>
                    </div>
                </div>
            </div>
            {/* MainBanner5 */}
            <div className="MainBanner5">
                <div className="MainBanner5Left">
                    <h1>HOW TO GET IN TOUCH WITH BHO CHIMNEY SWEEP?</h1>
                    <div className="MainBanner5LeftBox">
                        <h2>1</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Reach Out to Us</h3>
                            <h4>Contact our expert team by phone or visit our <b onClick={() => navigate(`/book${location.search}&service=airduct`)}>book an appointment page</b> to schedule your ducts service.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>2</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Provide Your Details</h3>
                            <h4>Share your address and any specific details about your home that could impact the service, ensuring our team is well-prepared.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>3</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Schedule Your Service</h3>
                            <h4>Discuss the urgency of your needs, and we’ll arrange a convenient date and time for our team to visit.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftBox">
                        <h2>4</h2>
                        <div className="MainBanner5LeftBoxRigth">
                            <h3>Receive a Customized Quote</h3>
                            <h4>Our local service technician will assess your requirements and provide a quote based on your ducts.</h4>
                        </div>
                    </div>
                    <div className="MainBanner5LeftAbutton">

                        <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>CALL NOW {CitiePhone}</a>
                        <a onClick={() => navigate(`/book${location.search}&service=airduct`)}>SCHEDULE ONLINE</a>
                    </div>

                </div>
                <div className="MainBanner5Right">
                    <img src={require(`../../ImagesLogos/Image2LogoAirDuct.png`)} alt="Air Duct Cleaning Near Me BHO" />
                    <div className="MainBanner5RightBubble1"></div>
                    <div className="MainBanner5RightBubble2"></div>
                </div>

            </div>
            {/* MainBanner6 */}
            <div className="MainBanner6">
                <div className="MainBanner6Left">
                    <h2>GOT QUESTIONS? WE'VE GOT ANSWERS.</h2>
                    <h3>Feel Free To Reach Out To Us By Phone. For The Fastest Response, We Are Available By Phone 24/7 And Ready To Provide You With A Complimentary Consultation.</h3>
                    <a className="MainBanner6LeftContact" onClick={() => window.location.hash = 'contact'}>CONTACT US</a>
                    <div className="MainBanner4FaqMore">
                        <Faq
                            data={data}
                            styles={styles}
                            config={config}
                        />
                    </div>
                </div>
                <div className="MainBanner6Right">
                    <img src={require(`../../ImagesLogos/Image2LogoAirDuct.png`)} alt="Chimney Sweep BHO | Chimney Repair BHO | Chimney Services BHO | Chimney Inspection BHO" />
                </div>
            </div>
            {/* MainBanner7 */}
            <div className="MainBanner7" id='reviews'>
                <h1>Real Testimonials from Our Valued Client in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}</h1>
                <div className="LocationReviewsLsit">
                    <div className="LocationReviewsLsitUnder">
                        {LocationReviewsData.slice(0, 36).map((A, index) =>
                            <div key={index} className="LocationReviewsBox">
                                <div className="LocationReviewsBoxLeft">
                                    {/* <h3>Open Now 24/7 • Top Rated • Same Day Service</h3> */}
                                    <span>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/checklist.png`)}></img>
                                    </span>
                                    <h2><img src={require(`../../Images/GoogleIcons.png`)}></img>Rated 5 By {A.customer_name}</h2>
                                    <h4>{A.review}</h4>
                                    <div className="LocationReviewsBoxLeftBox">
                                        <div className="LocationReviewsBoxLeftBoxBox">
                                            <h5>Service Provided:</h5>
                                            <h6>{A.service_type}</h6>
                                        </div>
                                        <div className="LocationReviewsBoxLeftBoxBox">
                                            <h5>Technician</h5>
                                            <h6>{A.tech_name}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="LocationReviewsLsitShodowR"></div>
                </div>
            </div>
            {/* locationsMainAirDuct */}
            {locationsMainAirDuct.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageAdsAirDuctLocation">
                    <div className="HomePageAdsAirDuctLocationLeft">
                        <h1>Our Service Area / Locations</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b> And Surrounding Areas</h2>
                        <h3>75-Radius Arround {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h3>
                        {locationsMainAirDuct.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                            <div key={index} className="HomePageAdsAirDuctLocationLeftBox">
                                <h4>{A.Location1}</h4>
                                <h5>{A.Address1}</h5>
                                <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>{CitiePhone}</a>
                            </div>
                        )}
                    </div>
                    <div className="HomePageAdsAirDuctLocationRight">
                        <div className="HomePageAdsAirDuctLocationRightBorder"></div>
                        <iframe src={locationsMainAirDuct.find(a => a.Phone == CitiePhone).Map} ></iframe>
                    </div>
                </div>
                : null}
            {/* MainBanner8 */}
            <div className="MainBanner8" id="contact">
                <div className="MainBanner8Left">
                    <h1>Get In Touch</h1>
                    <h2>Is There Anything Else You'd Like To Know?</h2>
                    <h3>We Are Available Via Phone Or By This Form. However If You Would Like A Quick Response We Are By Our Phones 24/7 To Give You A Phone Consultation Free Of Charge.</h3>
                    <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>Click To Call Us Now!</a>
                    <a onClick={() => navigate(`/book${location.search}&service=airduct`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Cleaning Near Me BHO" /></a>
                </div>
                <div className="MainBanner8Right">

                    <div className="ContactFirstBody">
                        <form className="contact-form" onSubmit={sendEmail}>
                            <h4>Don't Hesitate To Reach Out!</h4>
                            <h5>If you need help with a new service or have questions about an existing one, please reach out via phone or by this form. Our team is here to assist you!</h5>
                            <h2>Full Name</h2>
                            <input type="text" name="Full_Name" required onChange={(e) => {
                                setCustInfoUpdate(e => !e)
                                CustInfo.FirstName = e.target.value
                            }} />
                            <h2>Address</h2>
                            <input type="text" name="Country" required onChange={(e) => {
                                setCustInfoUpdate(e => !e)
                                CustInfo.Address = e.target.value
                            }} />
                            <div className='ContactFirsthhh'>
                                <div className="ContactFirsthhhBox">
                                    <h2>Phone</h2>
                                    <input type="tel" name="Phone" required onChange={(e) => {
                                        setCustInfoUpdate(e => !e)
                                        CustInfo.Phone = e.target.value
                                    }} />
                                </div>

                            </div>
                            <h2>Massage</h2>
                            <textarea className="Message" name="Message" id="" cols="30" rows="10" required onChange={(e) => {
                                setCustInfoUpdate(e => !e)
                                CustInfo.Message = e.target.value
                            }}></textarea>
                            {
                                FormSubmiting ?
                                    <button class="buttonload">
                                        <i class="fa fa-refresh fa-spin"></i>Loading
                                        {/* <input type="submit" value="SEND" /> */}
                                    </button>
                                    :
                                    null
                            }
                            {
                                !FormSubmiting ?
                                    <span>
                                        <input type="submit" value="CLICK TO SEND" />
                                        <input type="hidden" name="Company_From" defaultValue={`BHO Chimney Sweep | BHO`} />
                                        <input type="hidden" name="Company" defaultValue={`BHO Chimney Sweep | BHO`} />
                                    </span>
                                    :
                                    null
                            }


                        </form>
                    </div>
                </div>
            </div>
            {/* MainBanner4 */}
            <div className="MainBanner4">
                <div className="MainBanner4Right">
                    <h1>OUR AIR DUCTS AND DRYER VENTS SERVICES</h1>
                    <h2>
                        At BHO Chimney Sweep, we provide a full range of air duct services, including cleaning, inspection, repair, and maintenance. Our certified technicians are dedicated to ensuring your air duct system is clean, efficient, and operating at its best. We use only high-quality equipment and proven methods to deliver outstanding results, improving your indoor air quality, HVAC performance, and overall home comfort while giving you peace of mind.
                    </h2>
                    <div className="MainBafnner4RightBenefits">

                        <a className="Header1BoxMenuBox">Air Duct Cleaning</a>
                        <a className="Header1BoxMenuBox">Air Duct Repair</a>
                        <a className="Header1BoxMenuBox">Air Duct Installation</a>
                        <a className="Header1BoxMenuBox">Air Duct & Dryer Vent Inspection</a>
                        <a className="Header1BoxMenuBox">Dryer Vent Cleaning</a>
                        <a className="Header1BoxMenuBox">Dryer Vent Repair</a>
                        <a className="Header1BoxMenuBox">Dryer Vent Rerouting</a>
                        <a className="Header1BoxMenuBox">UV Light Installation</a>
                        <a className="Header1BoxMenuBox">Air Duct Sanitation</a>
                        <a className="Header1BoxMenuBox">Duct Maintenance</a>
                        <a className="Header1BoxMenuBox">Ducts Replacement</a>
                        <a className="Header1BoxMenuBox">Whole-House Air Duct Cleaning</a>
                        <a className="Header1BoxMenuBox">Commercial Air Duct Cleaning</a>
                        <a className="Header1BoxMenuBox">Residential Air Duct Services</a>
                        <a className="Header1BoxMenuBox">HVAC Duct Cleaning</a>
                        <a className="Header1BoxMenuBox">Duct Leak Detection</a>
                        <a className="Header1BoxMenuBox">Duct Sealing Services</a>
                        <a className="Header1BoxMenuBox">Vent Cover Replacement</a>
                        <a className="Header1BoxMenuBox">High-Efficiency Filter Installation</a>
                        <a className="Header1BoxMenuBox">Flexible Duct Replacement</a>
                        <a className="Header1BoxMenuBox">Metal Ductwork Repair</a>
                        <a className="Header1BoxMenuBox">Return Vent Cleaning</a>
                        <a className="Header1BoxMenuBox">Supply Vent Cleaning</a>
                        <a className="Header1BoxMenuBox">Air Flow Balancing</a>
                        <a className="Header1BoxMenuBox">Duct Odor Removal</a>
                        <a className="Header1BoxMenuBox">Allergen Reduction Duct Services</a>
                        <a className="Header1BoxMenuBox">Chimney Waterproofing</a>
                        <a className="Header1BoxMenuBox">Chimney Masonry Rebuild</a>
                        <a className="Header1BoxMenuBox">Gas Fireplace Repair</a>
                        <a className="Header1BoxMenuBox">Chimney Cleaning</a>
                        <a className="Header1BoxMenuBox">Chimney Inspection</a>
                        <a className="Header1BoxMenuBox">Chimney Repair</a>
                        <a className="Header1BoxMenuBox">Chimney Cap Replacement</a>
                        <a className="Header1BoxMenuBox">Smoke Chamber Repair</a>
                        <a className="Header1BoxMenuBox">Fireplace Damper Repair</a>

                    </div>
                </div>

            </div>
            {/* HomePageAdsAirDuctFooter */}
            <div className="HomePageAdsAirDuctFooter">
                <div className="HomePageAdsAirDuctFooterTop">
                    <div className="HomePageAdsAirDuctFooterTopTitle">
                        <img src={require(`../../Images/Music.png`)} />
                        <h1>BHO Sweep Clean And Neat<br />Can’t Be Beat!</h1>
                        <img src={require(`../../Images/Music.png`)} />
                    </div>
                    <div className="HomePageAdsAirDuctFooterTopImg">
                        <img src={require(`../../ImagesLogos/Image1LogoAirDuct.png`)} />
                    </div>
                </div>
                <div className="HomePageAdsAirDuctFooterBottom">
                    <div className="HomePageAdsAirDuctFooterBottomTop">
                        <img src={require(`../../ImagesLogos/Banner2LogoAirDuct.png`)} />
                        <p>Copyright 1975-2024 BHO Chimney Sweep. All rights reserved. All available services, hours of operations, pricing structure, and guarantees may vary by location.</p>
                        <div className="SiteMapDiv">
                            <h1>Privacy</h1>
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/terms-and-conditions">Terms And Conditions</a>
                        </div>
                    </div>
                    {locationsMainAirDuct.find(a => a.Phone == CitiePhone) ?
                        <div className="HomePageAdsAirDuctFooterMiddle">
                            {locationsMainAirDuct.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageAdsAirDuctLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        : null}
                    <div className="HomePageAdsAirDuctFooterBottomBottom">
                        <span>
                            <img src={require(`../../Images/tag.png`)} alt="" />
                            <a>www.bhochimneysweep.com</a>
                        </span>
                        <span>
                            <img src={require(`../../Images/tag.png`)} alt="" />
                            <a href={`tel:${CitiePhone}`} onClick={fireBhoCall}>{CitiePhone}</a>
                        </span>
                        <span>
                            <img src={require(`../../Images/tag.png`)} alt="" />
                            <a>info@bhochimneysweep.com</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

